import { gql } from '@apollo/client';
import { QUESTIONNAIRE_TEMPLATE_FRAGMENT } from '../fragments/questionnaireTemplates';

export const CREATE_QUESTIONNAIRE_TEMPLATE = gql`
  mutation CreateQuestionnaireTemplate(
    $input: CreateQuestionnaireTemplateInput!
  ) {
    createQuestionnaireTemplate(input: $input) {
      questionnaireTemplate {
        ...QuestionnaireTemplateFragment
      }
    }
  }
  ${QUESTIONNAIRE_TEMPLATE_FRAGMENT}
`;
